import { render, staticRenderFns } from "./AddLocationSeating.vue?vue&type=template&id=56ed0675&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddLocationSeating.vue"
export default component.exports